export default __webpack_public_path__ + "media/images/no-image-yet-47d6e9cfda5d6a7ddf0018869a59fd77.png";